import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { EditableGridFieldTypes, GridColumn, GridConfig, GridPaginationEvent } from '../../../components/sib-forms/grid/grid.config';
import { CampaignItem } from '../../../modals/campaigns/campaignItem';
import { GridComponent } from '../../../components/sib-forms/grid/grid.component';
import { FormControl, FormGroup } from '@angular/forms';
import { DateUtil } from '../../../helpers/date.util';
import { HoardingStatusService } from '../../../hoardings-operation/services/hoardings-status.service';
import { PaginationData } from '../../../modals/paginationdata';
import { catchError, map } from 'rxjs/operators';
import { NotificatoinsService } from '../../../services/notifications/notifications.service';
import { empty as observableEmpty } from 'rxjs';
import { CalculationService } from '../../../services/shared/calculationService';

@Component({
  selector: 'sib-expired-pending-unmounting-items',
  templateUrl: './expired-pending-unmounting-items.component.html',
  styleUrls: ['./expired-pending-unmounting-items.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ExpiredPendingUnmountingItemsComponent implements OnInit {

  @ViewChild(GridComponent)
  gridViewChildRef: GridComponent<CampaignItem>;

  gridConfig: GridConfig<CampaignItem> = new GridConfig<CampaignItem>();

  pendingUnmountingGroup: FormGroup;
  paginationData: PaginationData;
  paginationEvent: GridPaginationEvent;
  totalRecords: any;

  startDate: Date = new Date();
  endDate: Date = new Date();
  currentDate: Date = new Date();
  maxValidDateForSelection = this.calculationService.getDaysBefore(this.currentDate,1);

  columns: Array<GridColumn> = [
    {
      field: 'sr',
      name: 'sr',
      header: 'SR',
      required: true,
      editable: false,
      hidden: false,
      permanent: true,
      width: '3vw',
      default: true,
      displayFn: (data) => {
        if (data.sr) {
          return data.sr;
        } else {
          return '-';
        }
      }
    },
    {
      field: 'customId',
      name: 'HID',
      header: 'HID',
      required: true,
      editable: false,
      hidden: false,
      permanent: true,
      width: '8vw',
      default: true,
      sortable: true,
      styleClass: 'word-break-wrap',
      type: EditableGridFieldTypes.TEXT,
      filter: {
        matchMode: 'contains',
        placeHolder: 'Search'
      }
    },
    {
      field: 'district',
      name: 'district',
      header: 'District',
      required: true,
      editable: false,
      hidden: false,
      permanent: false,
      width: '7vw',
      default: true,
      sortable: true,
      styleClass: 'word-break-wrap',
      type: EditableGridFieldTypes.TEXT,
      filter: {
        matchMode: 'contains',
        placeHolder: 'Search'
      },
    },
    {
      field: 'city',
      name: 'city',
      header: 'City',
      required: true,
      editable: false,
      hidden: false,
      permanent: true,
      width: '7vw',
      default: true,
      sortable: true,
      styleClass: 'word-break-wrap',
      type: EditableGridFieldTypes.TEXT,
      filter: {
        matchMode: 'contains',
        placeHolder: 'Search'
      }
    },
    {
      field: 'areaName',
      name: 'area',
      header: 'Area',
      required: true,
      editable: false,
      hidden: false,
      permanent: true,
      width: '7vw',
      default: true,
      sortable: true,
      styleClass: 'word-break-wrap',
      type: EditableGridFieldTypes.TEXT,
      filter: {
        matchMode: 'contains',
        placeHolder: 'Search'
      },
      /* displayFn: (data) => {
        if (data.area) {
          return data.area.name;
        } else {
          return '-';
        }
      } */
    },
    {
      field: 'location',
      name: 'location',
      header: 'Location',
      required: true,
      editable: false,
      hidden: false,
      permanent: true,
      width: '20vw',
      default: true,
      sortable: true,
      type: EditableGridFieldTypes.TEXT,
      filter: {
        matchMode: 'contains',
        placeHolder: 'Search',
        custom: false
      },
    },
    {
      field: 'size',
      name: 'size',
      header: 'Size',
      required: true,
      editable: false,
      hidden: false,
      permanent: true,
      default: true,
      sortable: true,
      styleClass: 'word-break-wrap',
      type: EditableGridFieldTypes.TEXT,
      filter: {
        matchMode: 'contains',
        placeHolder: 'Search'
      },
      displayFn: (data) => {
        if (data.size) {
          return data.size;
        } else {
          return '-';
        }
      }
    },
    {
      field: 'employeeName',
      name: 'employee',
      header: 'Employee',
      required: true,
      editable: false,
      sortable: true,
      permanent: false,
      default: true,
      width: '7vw',
      styleClass: 'word-break-wrap',
      type: EditableGridFieldTypes.TEXT,
      filter: {
        matchMode: 'contains',
        placeHolder: 'Search'
      },
      displayFn: (data) => {
        if (data.employeeName) {
          return data.employeeName;
        } else {
          return '-';
        }
      }
    },
    {
      field: 'displayName',
      name: 'displayName',
      header: 'Display Name',
      required: true,
      editable: false,
      sortable: false,
      permanent: true,
      hidden: false,
      width: '8vw',
      styleClass: 'word-break-wrap',
      type: EditableGridFieldTypes.TEXT,
      filter: {
        matchMode: 'contains',
        placeHolder: 'Search'
      },
      displayFn: (data) => {
        if (data) {
          return data.displayName;
        } else {
          return '-';
        }
      }
    },
    {
      field: 'unmountingItems.mounter.fullName',
      name: 'mounter',
      header: 'Mounter',
      required: true,
      editable: false,
      hidden: false,
      permanent: true,
      width: '7vw',
      default: true,
      sortable: true,
      styleClass: 'word-break-wrap',
      type: EditableGridFieldTypes.TEXT,
      filter: {
        matchMode: 'contains',
        placeHolder: 'Search'
      },
      displayFn: (data) => {
        if (data && data.unmountingItems && data.unmountingItems.mounter && data.unmountingItems.mounter.id) {
          return data.unmountingItems.mounter.firstName + ' ' + data.unmountingItems.mounter.lastName;
        } else {
          return '-';
        }
      }
    },
    {
      field: 'itemStartDate',
      name: 'itemStartDate',
      header: 'Item St. Dt.',
      required: true,
      editable: false,
      sortable: true,
      width: '7vw',   //mentioned width for campaign start date ---> Raveena
      styleClass: 'word-break-wrap',
      type: EditableGridFieldTypes.TEXT,
      displayFn: (data) => {
        if (data) {
          return DateUtil.dategridFormatter(data.itemStartDate);
        } else {
          return '-';
        }
      },
    },
    {
      field: 'itemEndDate',
      name: 'itemEndDate',
      header: 'Item End Dt.',
      required: true,
      editable: false,
      sortable: true,
      width: '7vw',
      styleClass: 'word-break-wrap',
      type: EditableGridFieldTypes.TEXT,
      displayFn: (data) => {
        if (data) {
          return DateUtil.dategridFormatter(data.itemEndDate);
        } else {
          return '-';
        }
      },
    },
    {
      field: 'unmountingItems.creativeName',
      name: 'creativeName',
      header: 'Creative Name',
      required: true,
      editable: false,
      sortable: true,
      width: '9vw',
      styleClass: 'word-break-wrap',
      type: EditableGridFieldTypes.TEXT,
      filter: {
        matchMode: 'contains',
        placeHolder: 'Search'
      },
      displayFn: (data) => {
        if (data.unmountingItems && data.unmountingItems.creativeName !== 'Default') {
          return data.unmountingItems.creativeName
        } else {
          return '-';
        }
      },
    },
    {
      field: 'unmountingItems.date',
      name: 'mountingDate',
      header: 'Unmt. Date',
      required: true,
      editable: false,
      sortable: true,
      width: '7vw',
      styleClass: 'word-break-wrap',
      type: EditableGridFieldTypes.TEXT,
      displayFn: (data) => {
        if (data.unmountingItems) {
          return DateUtil.dategridFormatter(data.unmountingItems.date)
        } else {
          return '-';
        }
      },
    },
  ];

  constructor(
    private hoardingStatusService: HoardingStatusService,
    private notificationService: NotificatoinsService,
    private calculationService: CalculationService
  ) { }

  ngOnInit() {
    this.pendingUnmountingGroup = new FormGroup({
      gridControl: new FormControl()
    });

    this.startDate = this.calculationService.getDaysBefore(this.currentDate, 30);
    this.endDate = this.calculationService.getDaysBefore(this.currentDate,1);

    this.gridConfig.getDefaultModel = () => new CampaignItem();
    this.gridConfig.model = CampaignItem;
    this.gridConfig.editable = false;
    this.gridConfig.expandableRows = false;
    this.gridConfig.checkboxSelection = false;
    this.gridConfig.resizableColumns = false;
    this.gridConfig.shouldAddRowOnDelete = false;
    this.gridConfig.showColorCode = false;
    this.gridConfig.lazy = true;
    this.gridConfig.enablePagination = true;
    this.gridConfig.scrollable = true;
    this.gridConfig.paginatorConfig =
    {
      pageLinks: 1,
      rowsPerPageOptions: [10, 20, 50],
      alwaysShowPaginator: true,
    };

    this.gridConfig.dataLoadFunction = (paginationEvent: GridPaginationEvent) => {
      const endOfDay = new Date(this.endDate);
      endOfDay.setUTCHours(23, 59, 59, 999);
      paginationEvent.filters = { ...paginationEvent.filters, itemEndDate: { value: [this.startDate, endOfDay], matchMode: 'dateBetween' } };
      this.paginationData = {
        filters: paginationEvent.filters,
        sortField: 'unmountingItems.date',
        sortOrder: -1
      };
      if (!paginationEvent.sortField || paginationEvent.sortField === 'updatedDate') {
        paginationEvent = Object.assign(paginationEvent, this.paginationData)
      }

      return this.hoardingStatusService.create(paginationEvent, paginationEvent, '/webSearch/unmounting-items').pipe(
        map((response) => {
          this.paginationEvent = paginationEvent;
          this.totalRecords = response['data'].totalElements;

          let index = 1;

          response['data']['content'] = response['data']['content'].map((element) => {
            element.sr = index++;
            return element;
          })

          return response['data']['content'];
        }), catchError(error => {
          if (error.error.code === 412) {
            this.notificationService.info(error.error.message ? error.error.message : 'Server Error', 'Please Refresh');
          } else {
            this.notificationService.error(error.error.message ? error.error.message : 'Server Error', 'Please Refresh.');
          }
          return observableEmpty();
        })
      )
    }
  }

  onDateSelection(event, isStartDate: boolean) {
    this.gridViewChildRef.refresh();
  }

}
